import { List } from 'antd';
import styled from 'styled-components';
import { Radio } from 'components/atoms/radio';
import { Item, Title } from '../basics';

export const EventTypeItem = styled(Item)`
  flex-direction: column;
  padding: 0;

  > ${Title} {
    padding: var(--layout-01) var(--layout-01);
  }
`;

export const StyledList = styled(List)`
  border-top: 1px solid var(--border-color);
  margin-left: var(--layout-04);
  margin-bottom: var(--spacing-03);
`;

export const StyledRadio = styled(Radio)`
  flex: 0 0 var(--layout-04);
  margin: 0;
`;

export const TriggerItem = styled(Item)`
  margin-left: calc(-1 * var(--layout-04));
`;

export const TriggerName = styled(Title)`
  flex: 1 0 calc(55% - var(--layout-04));
`;
